import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

const jobCardDataSlice = createSlice({
  name: "Job Card Data",
  initialState,
  reducers: {
    setJobCardData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { data, setJobCardData } = jobCardDataSlice.actions;

export default jobCardDataSlice.reducer;
